import React from 'react';

import create from 'zustand';
import createContext from 'zustand/context';

const { Provider, useStore } = createContext<OverlayState>();

interface OverlayState {
  overlayOpen: boolean;
  setOverlayOpen: (val: boolean) => void;
  replyId: string | null;
  setReplyId: (val: string | null) => void;
}

const createStore = () =>
  create<OverlayState>(set => ({
    overlayOpen: false,
    setOverlayOpen: value =>
      set(() => ({
        overlayOpen: value,
        replyId: null,
      })),
    replyId: null,
    setReplyId: value =>
      set(() => ({
        replyId: value,
      })),
  }));

const OverlayStateProvider = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  return <Provider createStore={createStore}>{children}</Provider>;
};

export default OverlayStateProvider;
export { useStore as useOverlayStore };
